import React from 'react'
import { Route, Switch } from 'react-router'
import ReportDriverSurcharges from './ReportDriverSurcharges'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportDriverSurcharges} />
    </Switch>
)

export default Components
